import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { ICostingLevelArticleNr } from '../../../models/costing-level-article.model';
import { CostingLevelResource } from '../../../resources/costing-level.resource';
import { TransactionalDataResource } from '../../../resources/transactional-data.resource';
import { ICostingLevelArticleMappingState } from './costinglevel-article-mapping.state.model';

let _state: ICostingLevelArticleMappingState = {
    isLoading: false,
    mappings: [],
};

@Injectable({
    providedIn: 'root',
})
export class CostinglevelArticleMappingFacade {

    protected store$: BehaviorSubject<ICostingLevelArticleMappingState> = new BehaviorSubject<ICostingLevelArticleMappingState>(_state);

    constructor(private myTransactionalDataResource: TransactionalDataResource,
                private myCostingLevelResource: CostingLevelResource) {
    }

    public getStateSnapshot(): ICostingLevelArticleMappingState {
        return this.store$.value;
    }

    public subState(): Observable<ICostingLevelArticleMappingState> {
        return this.store$.asObservable();
    }

    public async fetchMappings(costingLevelId?: number): Promise<void> {
        this.setIsloading(true);
        const mappings: ICostingLevelArticleNr[] = await firstValueFrom(this.myTransactionalDataResource
            .getCostingLevelArticleMapping(costingLevelId)).catch(() => []);
        this.updateState({ ..._state, mappings });
        this.setIsloading(false);
    }

    public clearState(): void {
        this.updateState({
            isLoading: false,
            mappings: [],
        });
    }

    private setIsloading(isLoading: boolean): void {
        this.updateState({ ..._state, isLoading });
    }

    private updateState(state: ICostingLevelArticleMappingState): void {
        this.store$.next(_state = state);
    }

}
